import { cn } from "@tellescope/ui";
import { Tooltip } from "@tellescope/design-system";
import { type LucideIcon } from "lucide-react";
import { type ReactNode } from "react";

export interface EventMetadataRowProps {
  icon: LucideIcon;
  hoverLabel?: string;
  children?: ReactNode;
  fadedText?: boolean;
}

export const EventMetadataRow = ({ icon: Icon, hoverLabel, children, fadedText }: EventMetadataRowProps) => {
  if (!children) {
    return null;
  }

  if (!hoverLabel) {
    return (
      <>
        <Icon size={16} className="text-muted-foreground mt-[1.5px]" />
        {typeof children === "string" ? (
          <p className={cn("text-sm leading-snug font-light", fadedText && "text-muted-foreground")}>{children}</p>
        ) : (
          children
        )}
      </>
    );
  }

  return (
    <>
      <Tooltip>
        <Tooltip.Trigger>
          <Icon size={16} className="text-muted-foreground mt-[1.5px]" />
        </Tooltip.Trigger>
        <Tooltip.Content side="left">{hoverLabel}</Tooltip.Content>
      </Tooltip>
      {typeof children === "string" ? (
        <p className={cn("text-sm leading-snug font-light", fadedText && "text-muted-foreground")}>{children}</p>
      ) : (
        children
      )}
    </>
  );
};
